import { render } from "./summary.vue?vue&type=template&id=20d67190&scoped=true"
import script from "./summary.vue?vue&type=script&lang=js"
export * from "./summary.vue?vue&type=script&lang=js"

import "./summary.vue?vue&type=style&index=0&id=20d67190&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d67190"]])

export default __exports__